import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { useMemo } from 'react';
import sanitize from 'sanitize-html';
import styles from './TrustedHtml.module.css';
import { TrustedHtmlProps } from './types';

/**
 * Use this component for and only for inserting HTML we can trust.
 */
function TrustedHtml(t0) {
  const $ = _c(18);
  let className;
  let options;
  let props;
  let t1;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      as: t1,
      options,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = options;
    $[3] = props;
    $[4] = t1;
    $[5] = value;
  } else {
    className = $[1];
    options = $[2];
    props = $[3];
    t1 = $[4];
    value = $[5];
  }
  const as = t1 === undefined ? "span" : t1;
  const Tag = as;
  let t2;
  if ($[6] !== options || $[7] !== value) {
    t2 = value && sanitize(value, options);
    $[6] = options;
    $[7] = value;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const __html = t2;
  let t3;
  if ($[9] !== __html) {
    t3 = {
      __html
    };
    $[9] = __html;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== className) {
    t4 = classNames(className, styles.container);
    $[11] = className;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== Tag || $[14] !== props || $[15] !== t3 || $[16] !== t4) {
    t5 = <Tag dangerouslySetInnerHTML={t3} className={t4} {...props} />;
    $[13] = Tag;
    $[14] = props;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}
export default TrustedHtml;